<template>
  <main class="page feed-page" :class="roleAccessMessageArea ? 'feed-page--create' : ''" ref="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item feed__search" style="margin-right: 16px;">
          <SearchForm @form-submit="findPost"/>
        </div>
        <AppButtonFilter
          :active="filterIsActive"
          @click.native="toggleFilter"
        />
      </div>

      <transition name="fade">
        <Form
          v-model="filterData"
          :value="filter"
          @request="setFilter"
          ref="filterForm"
          v-if="filterIsActive"
          class="filter"
        >
          <div class="filter__list">
            <AppInputDate name="dateFrom" title="От" :value="filter.date_from"/>
            <AppInputDate name="dateTo" title="До" :value="filter.date_to"/>
            <AppSelect
              title="По автору"
              :value="filter.author"
              :options="usersList"
              newItemFromSearch
              is-users
              placeholder="Не выбрано"
              name="userAuthor"
            />
            <AppSelect
              title="Кому"
              :value="filter.recipient"
              :options="usersList"
              newItemFromSearch
              is-users
              placeholder="Не выбрано"
              name="userRecipient"
            />
          </div>
          <div class="filter__buttons">
            <AppButton
              type="main"
              title="Показать"
            />
            <AppButton
              type="alt"
              title="Сбросить"
              @click.stop.native="clearFilter"
            />
          </div>
        </Form>
      </transition>

    </section>

    <section class="section page__content feed-content">
      <div class="page__row">
        <h1 class="title">Новостная лента</h1>
      </div>
      <div class="page__column">
        <transition name="fade">
          <div class="post-list" v-if="posts.length !== 0">
            <transition-group name="fade">
               <div class="post-list__item"
                   v-for="post in posts"
                   :key="post.id"
                   :ref="post.itemable.id">
                  <FeedPost :post="post"
                            @toggle-controls="togglePostControls(post.id)"
                            @vote="votePoll"
                            @update-post="updatePost"
                            @remove-post="removePost"
                            @repeat-post="repeatPost(post.itemable.id, post.itemable.start_at , post.itemable.end_at)"
                  />
              </div>
            </transition-group>
          </div>
        </transition>
        <transition name="fade">
          <div class="page__row mb-20"  v-if="posts.length === 0">
            <div class="no-records">
              <AppNoRecordsPlaceholder text="Записи не найдены"/>
            </div>
          </div>
        </transition>
      </div>
    </section>
    <section class="section page__footer feed-footer"
             :class="footerActive ? 'active' : ''"
             v-if="roleAccessMessageArea"
             @click.stop
    >
      <div class="message-area">
        <ul class="message-tabs">
          <li class="message-tabs__item active">
            <span class="message-tabs__icon">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.2378 11.1798L13.7925 10.9524L13.6858 11.1612L13.7782 11.3768L14.2378 11.1798ZM12.0357 13.7202L12.1938 13.2459L11.9538 13.1659L11.7471 13.3119L12.0357 13.7202ZM15.875 15L15.7169 15.4743L16.7732 15.8264L16.3346 14.803L15.875 15ZM14.5 8C14.5 9.06404 14.2447 10.067 13.7925 10.9524L14.683 11.4072C15.2055 10.3843 15.5 9.22582 15.5 8H14.5ZM8 1.5C11.5899 1.5 14.5 4.41015 14.5 8H15.5C15.5 3.85786 12.1421 0.5 8 0.5V1.5ZM1.5 8C1.5 4.41015 4.41015 1.5 8 1.5V0.5C3.85786 0.5 0.5 3.85786 0.5 8H1.5ZM8 14.5C4.41015 14.5 1.5 11.5899 1.5 8H0.5C0.5 12.1421 3.85786 15.5 8 15.5V14.5ZM11.7471 13.3119C10.6882 14.0604 9.3962 14.5 8 14.5V15.5C9.6096 15.5 11.1021 14.9924 12.3243 14.1285L11.7471 13.3119ZM11.8776 14.1946L15.7169 15.4743L16.0331 14.5257L12.1938 13.2459L11.8776 14.1946ZM16.3346 14.803L14.6973 10.9828L13.7782 11.3768L15.4154 15.197L16.3346 14.803Z" fill="currentColor"/>
                <path d="M5 7H11" stroke="currentColor"/>
                <path d="M5 10H11" stroke="currentColor"/>
              </svg>
            </span>
            <span>Сообщение</span>
          </li>
          <li class="message-tabs__item"
              v-if="roleAccessActivity"
              @click.stop="openEventModal"
          >
            <span class="message-tabs__icon">
              <svg width="16" height="17" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5 0C4.44772 0 4 0.447715 4 1V3H2C0.895431 3 0 3.89543 0 5V19C0 20.1046 0.895431 21 2 21H6.25H7.75H12.25H13.75H18C19.1046 21 20 20.1046 20 19V5C20 3.89543 19.1046 3 18 3H16V1C16 0.447715 15.5523 0 15 0C14.4477 0 14 0.447715 14 1V3H6V1C6 0.447715 5.55228 0 5 0ZM18 19.5H13.75V15.25H18.5V19C18.5 19.2761 18.2761 19.5 18 19.5ZM18.5 13.75H13.75V10.25H18.5V13.75ZM12.25 13.75V10.25H7.75V13.75H12.25ZM6.25 13.75V10.25H1.5V13.75H6.25ZM1.5 15.25H6.25V19.5H2C1.72386 19.5 1.5 19.2761 1.5 19V15.25ZM7.75 15.25H12.25V19.5H7.75V15.25ZM14 4.5H6V5C6 5.55228 5.55228 6 5 6C4.44772 6 4 5.55228 4 5V4.5H2C1.72386 4.5 1.5 4.72386 1.5 5V8.75H18.5V5C18.5 4.72386 18.2761 4.5 18 4.5H16V5C16 5.55228 15.5523 6 15 6C14.4477 6 14 5.55228 14 5V4.5Z" fill="currentColor"/>
              </svg>
            </span>
            <span>Создать мероприятие</span>
          </li>
          <li class="message-tabs__item"
              v-if="roleAccessPoll"
              @click.stop="openPollModal"
          >
            <span class="message-tabs__icon">
              <svg width="17" height="16" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 10H18" stroke="currentColor" stroke-width="1.5"/>
                <path d="M10 15H18" stroke="currentColor" stroke-width="1.5"/>
                <path d="M0.75 0.75H17.1893L23.25 6.81066V11.5V22.25H0.75V0.75Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M5 8.8L6.2 10L8 8" stroke="currentColor" stroke-width="1.5"/>
                <path d="M5 14.8L6.2 16L8 14" stroke="currentColor" stroke-width="1.5"/>
              </svg>
            </span>
            <span>Создать опрос</span>
          </li>
        </ul>
        <div class="message-area__message-input">
          <AppMessageInput :value="message"
                           placeholder="Написать в ленту"
                           :blur-after-send="true"
                           @got-focus="showMessageArea"
                           @value-changed="setMessageValue"
                           @selection-range="setInputSelectionRange"
                           @send-message="sendMessage"
                           @paste-files="attachFiles"
                           :not-message="true"
          />
        </div>
        <div class="message-area__attachment-preview" v-if="attachment.files.length !== 0 || attachment.tags.length !== 0">
          <AppMessageAttachmentPreview :files="attachment.files"
                                       :tags="attachment.tags"
                                       :editable="true"
                                       @remove-file="removeFile"
                                       @remove-tag="removeTag"
          />
        </div>
        <div class="message-area__attachment">
          <AppMessageAttachment :link-tooltip="attachment.linkTooltip"
                                :tag-tooltip="attachment.tagTooltip"
                                @toggle-link-tooltip="toggleLinkTooltip"
                                @close-link-tooltip="closeLinkTooltip"
                                @set-link-url="setLinkUrl"
                                @toggle-tag-tooltip="toggleTagTooltip"
                                @close-tag-tooltip="closeTagTooltip"
                                @set-tag-text="setTagText"
                                @attach-files="attachFiles"
                                @attach-link="attachLink"
                                @attach-tag="attachTag"
                                @clear-validation="clearAttachmentValidation"
          />
        </div>
        <div class="message-area__bottom">
          <div class="message-area__recipients">
            <AppMessageRecipients title="Кому:"
                                  :is-active="recipients.active"
                                  :state="recipients"
                                  width="100%"
                                  style="max-width: 544px"
                                  @setUserSearch="setUserRecipientSearch"
                                  @toggle-check-recipient="toggleRecipient"
                                  @toggle="toggleRecipientsSelect"
                                  @close="closeRecipientsSelect"
            />
          </div>
          <div class="message-area__buttons">
            <div class="page__item">
              <AppButton :title="messageArea.updatedId ? 'Сохранить' : 'Отправить'"
                         type="third"
                         @click.native="sendMessage"
              />
            </div>
            <div class="page__item">
              <AppButton title="Отмена"
                         type="alt"
                         @click.native="cancelSend"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="bottom-line"></section>
    <transition name="fade">
      <EventModal v-if="eventModal.active"/>
    </transition>
    <transition name="fade">
      <PollModal v-if="pollModal.active"/>
    </transition>
    <transition name="fade">
      <BaseModal
        v-if="isVisibleModalRepeat"
        @close="isVisibleModalRepeat = false"
        title="Повторить мероприятие"
        style="max-width: 100%;"
      >
        <ActivityRepeatForm
          style="width: 300px"
          v-model="repeatFormData"
          @activityRepeatSubmit="activityRepeatSubmit"
          @cancel="isVisibleModalRepeat = false"
        />
        <!--        @constructingSubmit="createConstructingSubmit"-->
      </BaseModal>
    </transition>
    <ThePagePreloader v-if="isLoading" />
  </main>
</template>

<script>

import FeedPost from '../components/feed/FeedPost'
import AppMessageInput from '../components/page/input/AppMessageInput'
import AppMessageAttachment from '../components/page/input/AppMessageAttachment'
import AppButton from '../components/page/button/AppButton'
import AppMessageRecipients from '../components/page/input/AppMessageRecipients'
import SearchForm from '../components/page/input/SearchForm'
import EventModal from '@/components/page/modal/EventModal'
import AppMessageAttachmentPreview from '@/components/page/input/AppMessageAttachmentPreview'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import PollModal from '@/components/page/modal/PollModal'
import AppButtonFilter from '@/components/page/button/AppButtonFilter'
import AppInputDate from '@/components/page/input/AppInputDate'
import AppSelect from '@/components/page/input/AppSelect'
import Form from '@/components/page/Form/Form'
import BaseModal from '@/components/page/modal/base/BaseModal'
import ActivityRepeatForm from '@/components/activity/form/ActivityRepeatForm'
import { mapGetters } from 'vuex'
import axios from '@/utils/axios'
import { config } from '@/store'

export default {
  name: 'feed',
  components: {
    PollModal,
    AppNoRecordsPlaceholder,
    ThePagePreloader,
    AppMessageAttachmentPreview,
    EventModal,
    SearchForm,
    AppMessageRecipients,
    AppButton,
    AppMessageAttachment,
    AppMessageInput,
    FeedPost,
    AppButtonFilter,
    Form,
    AppSelect,
    AppInputDate,
    BaseModal,
    ActivityRepeatForm

  },
  data () {
    return {
      // для хранения ссылки на текущий инпут сообщения и его выделенной области
      messageInput: null,
      inputSelectionRange: null,
      filterData: {},
      filterIsActive: false,
      isVisibleModalRepeat: false,
      activity_id: null,
      repeatFormData: {}
    }
  },
  computed: {
    ...mapGetters({
      usersList: '[dictionaries] usersList',
      filter: 'getFeedFilter'
    }),
    posts () {
      return this.$store.getters.getFeedPosts
    },
    filter () {
      return this.$store.getters.getFeedFilter
    },
    footerActive () {
      return this.$store.getters.getFeedFooterActive
    },
    messageArea () {
      return this.$store.getters.getFeedMessageArea
    },
    message () {
      return this.$store.getters.getFeedMessage
    },
    recipients () {
      return this.$store.getters.getFeedRecipients
    },
    attachment () {
      return this.$store.getters.getFeedMessageAttachment
    },
    eventModal () {
      return this.$store.getters.getFeedEventModal
    },
    pollModal () {
      return this.$store.getters.getFeedPollModal
    },
    isLoading () {
      return this.$store.getters.getFeedIsLoading
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessMessageArea () {
      return this.$store.getters.getRoleRightsFeed.actionAccess
    },
    roleAccessActivity () {
      return this.$store.getters.getRoleRightsFeedActivity.actionAccess
    },
    roleAccessPoll () {
      return this.$store.getters.getRoleRightsFeedPoll.access
    },
    notificationCount () {
      return this.$store.getters.getNewNotificationCounter
    }
  },
  methods: {
    loadOptions () {
      this.$store.dispatch('[dictionaries] getUserList')
    },
    showMessageArea () {
      this.$store.dispatch('showFeedMessageArea')
    },
    setMessageValue (message) {
      this.$store.dispatch('setFeedMessageValue', message)
    },
    sendMessage () {
      this.$store.dispatch('sendFeedMessage')
      this.$refs.page.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    cancelSend () {
      this.$store.dispatch('cancelSendFeedMessage')
    },
    votePoll (payload) {
      this.$store.dispatch('[feed-poll] vote', payload)
    },
    // attachment
    attachFiles (files) {
      this.$store.dispatch('feedMessageAttachFiles', files)
    },
    removeFile (data) {
      this.$store.dispatch('feedMessageRemoveFile', data)
    },
    toggleLinkTooltip () {
      this.$store.dispatch('feedMessageToggleLinkTooltip')
      const range = this.inputSelectionRange
      if (range) {
        this.$store.dispatch('feedMessageSetLinkText', range.toString())
      } else {
        this.$store.dispatch('feedMessageSetLinkText', '')
      }
    },
    closeLinkTooltip () {
      this.$store.dispatch('feedMessageCloseLinkTooltip')
    },
    setInputSelectionRange (data) {
      this.messageInput = data.input

      // берем Range если не пустой, проверяем на наличие вложенных тегов (иначе обертывание в ссылку ломается), может быть undefined если выделено одно слово.
      if (!data.range.collapsed && (data.range.commonAncestorContainer.childElementCount === undefined || data.range.commonAncestorContainer.childElementCount === 0)) {
        this.inputSelectionRange = data.range
      } else {
        this.inputSelectionRange = null
      }
    },
    setLinkUrl (url) {
      this.$store.dispatch('feedMessageSetLinkUrl', url)
    },
    attachLink () {
      const range = this.inputSelectionRange
      const url = this.attachment.linkTooltip.url.indexOf('https://') + 1 ? this.attachment.linkTooltip.url : `https://${this.attachment.linkTooltip.url}`

      if (range && this.attachment.linkTooltip.url.length !== 0) {
        const linkTag = document.createElement('a')
        linkTag.setAttribute('target', '_blank')
        linkTag.setAttribute('title', url)
        linkTag.setAttribute('href', url)
        range.surroundContents(linkTag)
      }
      this.$store.dispatch('setFeedMessageValue', this.messageInput.innerHTML)
      this.$store.dispatch('feedMessageAttachLink')
    },
    toggleTagTooltip () {
      this.$store.dispatch('feedMessageToggleTagTooltip')
    },
    closeTagTooltip () {
      this.$store.dispatch('feedMessageCloseTagTooltip')
    },
    setTagText (text) {
      this.$store.dispatch('feedMessageSetTagText', text)
    },
    attachTag () {
      this.$store.dispatch('feedMessageAttachTag')
    },
    removeTag (index) {
      this.$store.dispatch('feedMessageRemoveTag', index)
    },
    clearAttachmentValidation () {
      this.$store.dispatch('feedMessageAttachmentClearValidation')
    },
    // /attachment
    setUserRecipientSearch (value) {
      this.$store.dispatch('[feed] setUserRecipientSearch', value)
    },
    toggleRecipient (recipient) {
      this.$store.dispatch('toggleFeedSelectedRecipient', recipient)
    },
    toggleRecipientsSelect () {
      this.$store.dispatch('toggleFeedRecipientsSelect')
    },
    closeRecipientsSelect () {
      this.$store.dispatch('closeFeedRecipientsSelect')
    },
    openEventModal () {
      this.$store.dispatch('showFeedEventModal')
    },
    openPollModal () {
      this.$store.commit('[feed-poll] OPEN_MODAL')
    },
    togglePostControls (postId) {
      this.$store.dispatch('toggleFeedPostControls', postId)
    },
    updatePost (data) {
      this.$store.dispatch('updateFeedPost', data)
    },
    removePost (postId) {
      this.$store.dispatch('removeFeedPost', postId)
    },
    repeatPost (postId, dateStart, dateEnd) {
      this.activity_id = postId
      this.repeatFormData = {
        start_time: dateStart,
        end_time: dateEnd
      }
      this.isVisibleModalRepeat = !this.isVisibleModalRepeat 
    },
    // repeat
    activityRepeatSubmit (data) {
      data = {
        ...data
      }
      const activity_id = this.activity_id
      axios.post(`/activities/${activity_id}/repeat`, data, config)
        .then(() => { })
        .finally(() => { this.isVisibleModalRepeat = false })
    },
    findPost (value) {
      this.$store.dispatch('setFeedSearchValue', value)
    },
    toggleFilter () {
      this.filterIsActive = !this.filterIsActive
    },
    closeFilter () {
      this.$store.dispatch('closeFeedFilter')
    },
    clearFilter () {
      this.$refs.filterForm.clear()
      this.$store.dispatch('clearFeedFilter')
    },
    setFilter (data) {
      const filter = {
        date_from: data.dateFrom,
        date_to: data.dateTo,
        author: { id: data.userAuthor.id, name: data.userAuthor.name },
        recipient: { id: data.userRecipient.id, name: data.userRecipient.name }
      }
      this.$store.commit('SET_FEED_LIST_FILTER', filter)
      this.$store.dispatch('getFeedPosts')
    },
    handleScroll () {
      const page = this.$refs.page

      if (page.scrollHeight - page.scrollTop === page.clientHeight) {
        this.$store.dispatch('getFeedPostsNextPage')
      }
    },
    initPage () {
      this.$store.dispatch('getFeedPosts')
      if (this.roleAccessMessageArea) this.$store.dispatch('getFeedRecipientsOptions')
      this.$store.dispatch('[feed] getRecipientUserOptions')
    }
  },
  mounted () {
    this.initPage()
    this.loadOptions()
    this.$refs.page.addEventListener('scroll', this.handleScroll)

    // заказчик попросил закрывать чат при переходе в ленту (ну и уведомления заодно закрываю)
    this.$store.commit('CLOSE_ASIDE_NOTIFICATION_WIDGET')
    this.$store.commit('CLOSE_ASIDE_DIALOG_WIDGET')
  },
  beforeDestroy () {
    // сбрасываем пагинацию и очищаем посты, чтобы при перезаходе на страницу не плюсовались дубликаты
    this.$store.dispatch('resetFeedContent')
  },
  watch: {
    notificationCount () {
      this.initPage()
    },
    posts (val) {
      if (val.length === 20) {
        const postId = this.$route.params?.postId
        if (postId) {
          this.$nextTick(() => {
            this.$refs[postId][0].scrollIntoView()
          })
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../assets/css/system/_vars';
@import '../assets/css/system/_mixins';

.feed {
  &__search {
    width: 682px;
  }
}

.feed-content {
  padding-bottom: 155px;
}

.feed-footer {
  position: fixed;
  z-index: 999;
  top: auto;
  bottom: -170px;
  left: 0;
  padding-bottom: 0;
  transition: .3s;

  &.active {
    transform: translate3d(0, -170px, 0);
  }

  &.deactive {
    animation: translateXDown .5s linear;
    animation-fill-mode: forwards;
  }
}

.bottom-line {
  position: fixed;
  z-index: 999;
  top: auto;
  bottom: 0;
  left: 0;
  background: $color_sixth;
  width: 100%;
  height: 25px;
}

.message-area {
  padding: 20px 100px 26px 290px;
  background: $color_sixth;
  border-top: 1px solid $border_color;

  &__message-input {
    border-radius: 3px 3px 0 0;
    overflow: hidden;
  }

  &__attachment {
    padding: 20px 15px;
    background: $color_main;
  }

  &__bottom {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    border-top: 1px solid $border_color;
    border-radius: 0 0 3px 3px;
    background: $color_main;
    padding: 25px 15px;
  }

  &__buttons {
    display: flex;
    flex-flow: row nowrap;

    .page__item {
      margin-right: 16px;
    }
  }

  &__attachment-preview {
    background: $color_main;
    padding: 12px 15px 0;
  }

  &__recipients {
    width: 100%;
    margin-right: 10px;
  }
}

.message-tabs {
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 20px;

  &__item {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    color: $font_color_second;
    cursor: pointer;
    transition: .3s;
    margin-right: 35px;

    &:hover {
      color: $font_color_third;
    }

    &.active {
      color: $font_color_third;
    }
  }

  &__icon {
    margin-right: 10px;
  }
}

.post-list {
  width: 100%;

  &__item {
    margin-bottom: 20px;
  }
}

.no-records {
  width: 100%;
  margin-top: 80px;
}

.feed-page {
  @media screen and (min-width: 1080px) {
    margin-right: 70px;
  }
}

.feed-page--create {
  &::-webkit-scrollbar-track {
    margin-bottom: 160px;
  }
}
</style>
